import React from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from "utils/util";
import CmsPreviewShell from "./CmsPreviewShell";

const ReviewComponent = ({ title, subtitle, layout, items = [] }) => {
  const navigate = useNavigate();
  const handleClick = (link) => linkOpen(link, navigate);

  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <div className={`cms-review cms-review--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-review__item" onClick={() => handleClick(item.link)}>
            <div className="cms-review__thumb">
              <img src={item.img} alt={item.title} />
            </div>
            <div className="cms-review__body">
              <div className="cms-review__rating">
                {"★".repeat(item.rating)}
                {"☆".repeat(5 - item.rating)}
              </div>
              <h5 className="cms-review__title">{item.title}</h5>
              <p className="cms-review__desc">{item.description}</p>
              {/* <span className="cms-review__author">{item.author}</span> */}
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default ReviewComponent;
